import apiClient from './index';

const getCurtainTemplatePath = ({curtainType}) => {
  return `curtains/${curtainType}/template/`
}
const getAccessoryTemplatePath = ({accessoryType}) => {
  return `accessories/${accessoryType}/template/`
}

export default {
  async getCurtainTemplate(urlParams, data) {
    return await apiClient.post(getCurtainTemplatePath(urlParams), data)
  },
  async getAccessoryTemplate(urlParams, data) {
    return await apiClient.post(getAccessoryTemplatePath(urlParams), data)
  }
}
